import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { destinations } from "../data/destinations";

const Header = () => {
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setDropdownOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	const closeDropdown = () => setDropdownOpen(false);

	return (
		<header className="site-header">
			<nav className="site-nav">
				<NavLink
					to="/"
					end
					className={({ isActive }) =>
						`nav-button${isActive ? " nav-button-active" : ""}`
					}
				>
					HOME
				</NavLink>

				<div className="nav-dropdown" ref={dropdownRef}>
					<button
						type="button"
						className={`nav-button nav-dropdown-toggle${
							dropdownOpen ? " nav-button-active" : ""
						}`}
						onClick={() => setDropdownOpen((open) => !open)}
						aria-expanded={dropdownOpen}
						aria-haspopup="true"
					>
						DESTINATION
						<span className="nav-dropdown-arrow">
							{dropdownOpen ? "▲" : "▼"}
						</span>
					</button>

					{dropdownOpen && (
						<ul className="nav-dropdown-menu">
							{destinations.map((destination) => (
								<li key={destination.slug}>
									<Link
										to={`/destinations/${destination.slug}`}
										className="nav-dropdown-item"
										onClick={closeDropdown}
									>
										<span>{destination.title}</span>
										<strong>{destination.price}</strong>
									</Link>
								</li>
							))}
						</ul>
					)}
				</div>
			</nav>
		</header>
	);
};

export default Header;
